module.exports = __webpack_public_path__ + "img/PLC-1.778d4d69.png";